import { logout } from "action/AuthAction";
import { ProfileWalletAmountResp } from "domain/payload/response/profile/ProfileWalletAmountResp";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ProfileService from "service/ProfileService";

const ProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const customerServiceUrl = useSelector((state: any) => state.config.customerServiceUrl);
  const { profile } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();

  const profileService = ProfileService();

  const [walletAmount, setWalletAmount] = useState<ProfileWalletAmountResp | null>(null);
  const [isLoadingWalletAmount, setIsLoadingWalletAmount] = useState(false);

  const [email, setEmail] = useState(profile.email);

  const generateInitials = (name: string) => {
    if (name == null) {
      return ""
    }
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase();
  };

  const loadWalletAmount = async () => {
    try {
      setIsLoadingWalletAmount(true);
      const resp = await profileService.getWalletAmount();
      setWalletAmount(resp.data ?? null);
    } catch (e: any) {
      console.error("Failed to load wallet amount:", e);
    } finally {
      setIsLoadingWalletAmount(false);
    }
  };

  const handleLogout = async () => {
    try {
      navigate("/sign-in");

      dispatch(logout());
    } catch (e: any) {
      console.log(JSON.stringify(e.message));
    }
  };

  useEffect(() => {
    loadWalletAmount();
  }, []);

  return (
    <div className="container bg-white rounded-top pb-5">
      <div className="text-center mt-4">
        <div
          className="rounded-circle mx-auto d-flex align-items-center justify-content-center fw-bold"
          style={{
            width: 90,
            height: 90,
            background: "#20A1F1",
            overflow: "hidden",
            fontSize: 28,
            color: "#fff",
          }}
        >
          {profile?.profilePicture ? (
            <img
              src={profile.profilePicture}
              alt="Profile"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            generateInitials(profile?.name)
          )}
        </div>
        <h5 className="fw-bold mt-3 mb-1">{profile.name}</h5>
        <div className="text-muted small">{email}</div>
        <div className="text-muted small">{profile.phone}</div>
      </div>

      <div className="card shadow-sm border-0 mt-4 w-100">
        <div className="card-body d-flex align-items-center">
          <div className="menu-icon me-3" style={{ fontSize: 24 }}>
            <i className="fa fa-wallet"></i>
          </div>
          <div>
            <div className="text-primary small fw-semibold">TransWallet</div>
            {
              isLoadingWalletAmount ? (
                <div className="spinner-border spinner-border-sm text-primary" />
              ) :
                <div className="fw-bold">
                  {new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0,
                  }).format(walletAmount?.cashBalance ?? 0)}
                </div>
            }
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm mt-4">
        <div className="list-group profile-menu">
          <button
            className="list-group-item d-flex align-items-center py-3 rounded mb-2"
            onClick={() => navigate("/profile/edit")}
          >
            <div className="menu-icon me-3">
              <i className="fa fa-pencil"></i>
            </div>

            <span className="flex-grow-1 text-start">Edit Profile</span>
            <span className="arrow">›</span>
          </button>

          <button
            className="list-group-item d-flex align-items-center py-3 rounded mb-2"
            onClick={() => navigate("/profile/faq")}
          >
            <div className="menu-icon me-3">
              <i className="fa fa-question-circle"></i>
            </div>

            <span className="flex-grow-1 text-start">FAQ</span>
            <span className="arrow">›</span>
          </button>

          <Link to={customerServiceUrl} target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}>
            <button
              className="list-group-item d-flex align-items-center py-3 rounded mb-2 w-100"
            >
              <div className="menu-icon me-3">
                <i className="fa fa-headset"></i>
              </div>

              <span className="flex-grow-1 text-start">Customer Service</span>
              <span className="arrow">›</span>
            </button>
          </Link>

          {/* <button
            className="list-group-item d-flex align-items-center py-3 rounded mb-2 text-danger"
            onClick={handleLogout}
          >
            <div className="menu-icon me-3 text-danger">
              <i className="fa fa-right-from-bracket"></i>
            </div>

            <span className="flex-grow-1 text-start">Log Out</span>
            <span className="arrow">›</span>
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;